module.exports = __webpack_public_path__ + "media/open.cc63cfb4.mp3";